var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSearch = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10.923,
  height: 12.141,
  viewBox: "0 0 10.923 12.141",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_143",
  "data-name": "Group 143",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M97.668,137.462a.289.289,0,0,0,.184-.066l1.184-.962a.29.29,0,0,0,.042-.409L96.1,132.364a4.389,4.389,0,1,0-3.947,1.709,4.264,4.264,0,0,0,.461.024,4.362,4.362,0,0,0,1.846-.409l2.978,3.666A.288.288,0,0,0,97.668,137.462Zm-5.355-4.887a2.88,2.88,0,1,1,2.114-.629A2.865,2.865,0,0,1,92.313,132.575Z",
  transform: "translate(-88.221 -125.322)",
  fill: "#949494"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_search.19535981.svg";
export { ForwardRef as ReactComponent };